module.exports = __webpack_public_path__ + "img/02_uk.de6b474e.svg";